import React, { useState, useMemo } from 'react';
import { logAuditAction } from '../../../utils/auditLogger';
import './styles/PanelCorrelaciones.css';

const PanelCorrelaciones = ({
  markerWOR,
  setMarkerWOR,
  CreateCisModalOpen,
  setDataAnalisis,
  setDataAffiliation,
}) => {
  const [isCollapsed,    setIsCollapsed]    = useState(false);
  const [selectedHostId, setSelectedHostId] = useState('');

  /* ── Totales para badges del header ───────────────────────── */
  const totales = useMemo(() => {
    let exc = 0, mtto = 0, total = 0;
    markerWOR.forEach(f => {
      const stats =
        typeof f.properties.stats === 'string'
          ? JSON.parse(f.properties.stats)
          : f.properties.stats;
      exc   += stats?.breakdown?.exceptions  || 0;
      mtto  += stats?.breakdown?.maintenance || 0;
      total += stats?.total_devices          || 0;
    });
    return { exc, mtto, total };
  }, [markerWOR]);

  /* ── Lista plana de hosts ──────────────────────────────────── */
  const hostsDisponibles = useMemo(() => {
    const list = [];
    markerWOR.forEach(feature => {
      if (!feature.properties?.hosts) return;
      const hostsArray =
        typeof feature.properties.hosts === 'string'
          ? JSON.parse(feature.properties.hosts)
          : feature.properties.hosts;
      if (Array.isArray(hostsArray)) {
        hostsArray.forEach(host =>
          list.push({
            id:             host.id,
            name:           host.name,
            is_exception:   host.is_exception,
            in_maintenance: host.in_maintenance,
          })
        );
      }
    });
    return list;
  }, [markerWOR]);

  /* ── Host seleccionado ─────────────────────────────────────── */
  const selectedHost = hostsDisponibles.find(h => h.id === selectedHostId);

  /* ── Toggle de atributo ────────────────────────────────────── */
  const toggleAttribute = attribute => {
    if (!selectedHostId) return alert('Selecciona un host primero');

    const updatedData = markerWOR.map(feature => {
      let wasUpdated = false;
      const newHosts = feature.properties.hosts.map(host => {
        if (host.id === selectedHostId) {
          wasUpdated = true;
          return { ...host, [attribute]: !host[attribute] };
        }
        return host;
      });

      if (!wasUpdated) return feature;

      const exceptionCount   = newHosts.filter(h => h.is_exception).length;
      const maintenanceCount = newHosts.filter(h => h.in_maintenance).length;
      let newStatus = feature.properties.tags?.main_status || 'OK';
      if (maintenanceCount > 0)     newStatus = 'MAINTENANCE';
      else if (exceptionCount > 0)  newStatus = 'EXCEPTION';

      return {
        ...feature,
        properties: {
          ...feature.properties,
          hosts: newHosts,
          stats: {
            ...(feature.properties.stats || {}),
            breakdown: {
              ...((feature.properties.stats?.breakdown) || {}),
              exceptions:  exceptionCount,
              maintenance: maintenanceCount,
            },
          },
          tags: { ...(feature.properties.tags || {}), main_status: newStatus },
        },
      };
    });

    setMarkerWOR(updatedData);

    const attrName = attribute === 'is_exception' ? 'Excepción' : 'Mantenimiento';
    const newState = !selectedHost[attribute] ? 'Activado' : 'Desactivado';
    
    logAuditAction("Editar", `Host '${selectedHost.name}' - ${attrName} ${newState}`, "Estado de Hosts");
  };

  if (CreateCisModalOpen) return null;

  return (
    <div className="gh-panel">

      {/* Header */}
      <div className="gh-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <div className="gh-header-left">
          <span className="gh-title">Gestión de hosts</span>
          {totales.exc > 0 && (
            <span className="gh-badge gh-badge--exc">{totales.exc} exc</span>
          )}
          {totales.mtto > 0 && (
            <span className="gh-badge gh-badge--mtto">{totales.mtto} mtto</span>
          )}
        </div>
        <span className="gh-toggle">{isCollapsed ? '＋' : '－'}</span>
      </div>

      {/* Hint siempre visible */}
      <div className="gh-hint">
        <span className="gh-hint-dot gh-hint-dot--exc" /> Excepción &nbsp;
        <span className="gh-hint-dot gh-hint-dot--mtto" /> Mantenimiento
      </div>

      {/* Cuerpo colapsable */}
      {!isCollapsed && (
        <div className="gh-body">

          <div className="gh-field">
            <label className="gh-label">Host</label>
            <select
              className="gh-select"
              value={selectedHostId}
              onChange={e => setSelectedHostId(e.target.value)}
            >
              <option value="">Seleccionar...</option>
              {hostsDisponibles.map(h => (
                <option key={h.id} value={h.id}>
                  {h.name}
                  {h.is_exception    ? ' ⚠' : ''}
                  {h.in_maintenance  ? ' 🔧' : ''}
                </option>
              ))}
            </select>
          </div>

          {/* Chips de estado del host seleccionado */}
          {selectedHost && (
            <div className="gh-status-row">
              <span className={`gh-chip ${selectedHost.is_exception   ? 'gh-chip--exc-on'  : 'gh-chip--off'}`}>
                Excepción {selectedHost.is_exception   ? 'ON' : 'OFF'}
              </span>
              <span className={`gh-chip ${selectedHost.in_maintenance ? 'gh-chip--mtto-on' : 'gh-chip--off'}`}>
                Mtto {selectedHost.in_maintenance ? 'ON' : 'OFF'}
              </span>
            </div>
          )}

          <div className="gh-actions">
            <button className="gh-btn gh-btn--exc"  onClick={() => toggleAttribute('is_exception')}>
              ± Excepción
            </button>
            <button className="gh-btn gh-btn--mtto" onClick={() => toggleAttribute('in_maintenance')}>
              ± Mantenimiento
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default PanelCorrelaciones;
